<template>
    <div>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="6"
                    lg="4"
                    xl="3"
                    v-for="(card, index) in photoCards"
                    :key="card.src"
                >
                    <v-card
                        class="soli-round"
                        style="border: none"
                        :ripple="false"
                        :disabled="card.disabled"
                        @click="
                            expand == index
                                ? (expand = null)
                                : [
                                      (expand = index),
                                      getApiEvents(card, index),
                                      getApiGiftCards(card, index),
                                      getApiSummerCamps(card, index),
                                  ]
                        "
                    >
                        <v-img
                            :src="card.src"
                            :lazy-src="card.lazy"
                            height="400"
                        ></v-img>
                        <v-card-actions>
                            <div style="height: 100px">
                                <v-card-title>{{ card.title }}</v-card-title>
                                <v-card-subtitle>{{
                                    card.subtitle
                                }}</v-card-subtitle>
                            </div>
                            <v-spacer />
                            <v-btn class="ma-3" icon>
                                <v-icon>{{
                                    expand == index
                                        ? "expand_less"
                                        : "expand_more"
                                }}</v-icon>
                            </v-btn>
                        </v-card-actions>
                        <v-expand-transition class="soli-round">
                            <v-card
                                v-if="expand == index"
                                class="transition-fast-in-fast-out v-card--reveal soli-round"
                                style="height: 100%; border: none"
                            >
                                <v-card-title>{{ card.title }}</v-card-title>
                                <v-card-subtitle>{{
                                    card.subtitle
                                }}</v-card-subtitle>
                                <v-btn
                                    v-if="card.nearMe && $page.props.auth.user"
                                    plain
                                    :ripple="false"
                                    style="
                                        position: absolute;
                                        top: 0px;
                                        right: 0px;
                                    "
                                    :class="['ma-3']"
                                    @click.stop="
                                        [
                                            (nearMe = !nearMe),
                                            getApiEvents(card, index),
                                        ]
                                    "
                                >
                                    <small class="mr-2">{{
                                        nearMe ? "Near Me" : "All"
                                    }}</small>
                                    <v-icon :color="nearMe ? 'secondary' : null"
                                        >near_me</v-icon
                                    ></v-btn
                                >
                                <v-container class="px-6" v-if="!card.events">
                                </v-container>
                                <v-skeleton-loader
                                    class="mx-auto"
                                    max-width="300"
                                    type="list-item, list-item, list-item"
                                    v-if="eventsLoading"
                                ></v-skeleton-loader>
                                <v-container
                                    v-if="
                                        card.events &&
                                        !card.timeline &&
                                        !card.registration
                                    "
                                    class="pt-0"
                                    @click.stop
                                >
                                    <v-form
                                        @submit.prevent="purchaseGiftCard"
                                        ref="giftCardForm"
                                    >
                                        <v-list>
                                            <v-btn-toggle
                                                v-model="giftCardForm.price"
                                                mandatory
                                                dense
                                                class="w-full mb-3"
                                            >
                                                <v-col
                                                    cols="12"
                                                    class="pa-0 ma-0"
                                                >
                                                    <v-list-item
                                                        v-for="event in card.events"
                                                        :key="event.amount"
                                                    >
                                                        <SoliBtn
                                                            block
                                                            :text="
                                                                formatUnitAmount(
                                                                    event.amount
                                                                )
                                                            "
                                                            :value="event"
                                                            color="soli-grey"
                                                            outlined
                                                            class="mb-3"
                                                        ></SoliBtn>
                                                    </v-list-item>
                                                </v-col>
                                            </v-btn-toggle>
                                            <SoliText
                                                v-if="$page.props.auth.user"
                                                v-model="giftCardForm.email"
                                                :errors="errors.email"
                                                :rules="rules.email"
                                                hideDetails
                                                icon="alternate_email"
                                                label="Your email"
                                                class="px-3 mb-3"
                                            ></SoliText>
                                        </v-list>
                                        <div class="px-3">
                                            <SoliBtn
                                                gradient="gradient-orange"
                                                type="submit"
                                                text="Buy Now"
                                                block
                                                :loading="giftCardFormLoading"
                                                :disabled="
                                                    $page.props.auth.user
                                                        ? !giftCardForm.email
                                                        : false
                                                "
                                            ></SoliBtn>
                                        </div>
                                        <small
                                            class="flex justify-center soli-grey mt-1 px-4"
                                            >Printable certificate, good for
                                            services at any Musicologie
                                            location.</small
                                        ></v-form
                                    ></v-container
                                >
                                <v-timeline
                                    align-top
                                    dense
                                    v-if="card.events && card.timeline"
                                    style="height: 358px; overflow-y: auto"
                                >
                                    <div
                                        v-if="
                                            !card.events.length &&
                                            !eventsLoading
                                        "
                                        class="flex justify-center"
                                    >
                                        No events found
                                    </div>
                                    <v-timeline-item
                                        v-for="event in card.events"
                                        :key="event.id"
                                        fill-dot
                                    >
                                        <template v-slot:icon>
                                            <small class="white--text">{{
                                                event.weekday ||
                                                formatUnitAmount(
                                                    event.price
                                                ).split(".")[0]
                                            }}</small>
                                        </template>
                                        <v-row class="mb-5 mr-1 pt-1.5 pl-2"
                                            ><v-card
                                                @click.stop="
                                                    card.action
                                                        ? card.action(event)
                                                        : $emit(
                                                              'selectClass',
                                                              event
                                                          )
                                                "
                                                class="row soli-round"
                                                outlined
                                            >
                                                <v-col
                                                    cols="3"
                                                    style="display: grid"
                                                    v-if="!event.wide"
                                                >
                                                    <strong>{{
                                                        `${event.start}`
                                                    }}</strong>
                                                    <small>{{
                                                        event.date
                                                    }}</small>
                                                </v-col>
                                                <v-col style="display: grid">
                                                    <!--<strong>{{ event.title }}</strong>-->
                                                    <strong>{{
                                                        event.description
                                                    }}</strong>
                                                    <small>
                                                        {{
                                                            event.location.name
                                                        }}
                                                    </small>
                                                </v-col>
                                            </v-card>
                                        </v-row>
                                    </v-timeline-item>
                                </v-timeline>
                                <v-container
                                    v-if="
                                        card.events &&
                                        !card.timeline &&
                                        card.registration
                                    "
                                    class="pt-0"
                                    style="height: 358px; overflow-y: auto"
                                    @click.stop
                                    ><v-card
                                        v-for="event in card.events"
                                        :key="event.id"
                                        :href="card.register"
                                        class="soli-round pa-4 mb-3"
                                        outlined
                                    >
                                        <strong class="flex">{{
                                            event.title
                                        }}</strong
                                        ><small>{{ event.description }}</small
                                        ><v-card-actions class="justify-end"
                                            ><v-btn
                                                rounded
                                                color="primary"
                                                :href="event.register"
                                                >Register</v-btn
                                            ></v-card-actions
                                        ></v-card
                                    >
                                </v-container>
                                <v-card-actions
                                    v-if="card.learn"
                                    class="pa-3 justify-end w-full white"
                                    style="
                                        position: absolute;
                                        bottom: 0px;
                                        right: 0px;
                                        z-index: 3;
                                    "
                                >
                                    <v-btn
                                        text
                                        plain
                                        :href="`https://musicologielessons.com/${card.learn}`"
                                        target="_blank"
                                        v-if="card.learn"
                                    >
                                        Learn More
                                    </v-btn>
                                    <v-btn
                                        class="gradient-orange white--text soli-round"
                                        v-if="card.getStarted"
                                        @click="$emit('createLesson', true)"
                                        >Get Started</v-btn
                                    >
                                </v-card-actions>
                            </v-card>
                        </v-expand-transition>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";
import confetti from "canvas-confetti";

export default {
    mixins: [globalMoment],
    props: ["successMessage", "errors"],
    data() {
        return {
            giftCardFormLoading: false,
            giftCardForm: {
                price: null,
                email: this.$page.props.auth.user
                    ? this.$page.props.auth.user.email
                    : null,
                img_url: null,
                code: null,
            },
            rules: {
                email: [
                    (v) => !!v || "E-mail is required",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
                ],
            },
            nearMe: !!this.$page.props.auth.user,
            expand: null,
            eventsLoading: false,
            photoCards: [
                {
                    title: "Accelerated Piano Lab",
                    subtitle: "Grow together at your own pace",
                    src: "/apl-assessment-tiny.webp",
                    learn: "/accelerated-piano-lab/",
                    timeline: true,
                    events: [],
                    nearMe: true,
                },
                {
                    title: "RockStars",
                    subtitle: "Take the stage!",
                    src: "/rockStars.webp",
                    learn: "/rock-band",
                    timeline: true,
                    events: [],
                    nearMe: true,
                },
                {
                    title: "Musicologie Junior",
                    subtitle:
                        "A musical adventure for toddlers and their adults",
                    src: "/junior-tiny.webp",
                    learn: "/musicologie-junior",
                    nearMe: true,
                    events: [],
                    timeline: true,
                    action: (event) => {
                        this.$inertia.visit(
                            route("classRegistration.edit", event.id)
                        );
                    },
                },
                /*{
                    title: "Drop-in Lessons",
                    subtitle: "A-la-carte lessons for any schedule",
                    src: "/drop-in-tiny.webp",
                    nearMe: false,
                    learn: "/private-lessons",
                    getStarted: true,
                    events: [
                        {
                            title: "6-pack",
                            description:
                                "Six 30-minute lessons - schedule anytime!",
                            price: "$196",
                            wide: true,
                            action: this.addToCart,
                        },
                        {
                            title: "12-pack",
                            description:
                                "Twelve 30-minute lessons - schedule anytime!",
                            price: "$378",
                            wide: true,
                            action: this.addToCart,
                        },
                    ],
                },*/
                /*{
                    title: "Concerts",
                    subtitle: "Show off. Be heard.",
                    src: "/concerts.webp"
                },*/
                /*{
                    title: "Member Events",
                    timeline: true,
                    subtitle:
                        "Unique experiences for Musicologie students and families",
                    src: "/member-events-tiny.webp",
                    nearMe: true,
                    //disabled: true,
                },*/
                {
                    title: "Summer Music Camps",
                    timeline: false,
                    subtitle:
                        "Embark on a musical adventure like no other! For ages 4-15.",
                    src: "/summer-camp.webp",
                    nearMe: false,
                    learn: "camp",
                    events: [],
                    registration: true,
                    //disabled: true,
                },
                {
                    title: "Gift Cards",
                    subtitle:
                        "Give experience and knowledge that will last a lifetime",
                    nearMe: false,
                    events: null,
                    src: [10, 11].includes(moment().month())
                        ? "gift-cards-holidays.gif"
                        : "gift-cards-white.webp",
                },
            ],
        };
    },
    methods: {
        confetti() {
            confetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 },
            });
        },
        getApiEvents(clickData, index) {
            if (!clickData.nearMe) return;
            this.eventsLoading = true;
            this.photoCards[index].events = [];
            return axios
                .get("/api/lessons/upcoming-group-events", {
                    params: {
                        title: clickData.title,
                        nearMe: !!this.nearMe
                            ? this.$page.props.auth.user.selected_location
                                  ?.market_id
                            : null,
                    },
                })
                .then((resp) => {
                    resp.data.map((event) => {
                        this.photoCards[index].events.push({
                            id: event.id,
                            location: event.location,
                            title: event.group_event.title,
                            description: `with ${event.teacher.name}`,
                            start: this.globalMomentTime(
                                new Date(event.starts_at)
                            ),
                            date: this.globalMomentDateDots(
                                new Date(event.starts_at)
                            ),
                            weekday: this.globalMomentWeekDayShort(
                                new Date(event.starts_at)
                            ),
                        });
                    });
                    this.eventsLoading = false;
                });
        },
        getApiSummerCamps(clickData, index) {
            if (!clickData.registration) return;
            this.eventsLoading = true;
            this.photoCards[index].events = [];
            return axios
                .get("/api/group-event/search/type", {
                    params: {
                        eventType: "Summer Camp",
                    },
                })
                .then((resp) => {
                    resp.data.map((event) => {
                        this.photoCards[index].events.push({
                            title: event.title,
                            description: event.description,
                            id: event.id,
                            register: event.register,
                        });
                    });
                    this.eventsLoading = false;
                });
        },
        getApiGiftCards(card, index) {
            if (card.title !== "Gift Cards") return;
            this.eventsLoading = true;
            return axios.get(route("stripe.giftCards")).then((resp) => {
                this.photoCards.find((e) => e.title == "Gift Cards").events =
                    resp.data.giftCards.map((e) => {
                        return {
                            title: "Gift Card",
                            amount: e.unit_amount,
                            wide: true,
                            action: this.addToCart,
                            id: e.id,
                        };
                    });
                this.eventsLoading = false;
            });
        },
        purchaseGiftCard() {
            if (!this.$refs.giftCardForm[0].validate()) return;
            this.giftCardFormLoading = true;
            this.$inertia.get(route("gift.create"), this.giftCardForm, {
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                    this.giftCardFormLoading = false;
                },
            });
        },
    },
};
</script>
